/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import Header from '../Header'
import locationIcon from '../../assets/icons/ic_location.svg'
//import followMe from '../../assets/icons/ic_followme.svg'
import targetIcon from '../../assets/icons/ic_target.svg'
import escortIcon from '../../assets/icons/ic_escort.svg'
import speakerIcon from '../../assets/icons/ic_speaker.svg'
import messageIcon from '../../assets/icons/ic_message.svg'
//import screenIcon from '../../assets/icons/ic_screen.svg'
import videosIcon from '../../assets/icons/ic_videotape.svg'
import qrIcon from '../../assets/icons/ic_qrcode.svg'
import checkIcon from '../../assets/icons/ic_check.svg'
import deliverIcon from '../../assets/icons/ic_deliver.svg'
import fetchIcon from '../../assets/icons/ic_fetch.svg'
import IconTint from 'react-icon-tint';
import Footer from '../models/TaskModel'
import { collection, doc, getDoc, onSnapshot } from 'firebase/firestore'
import { db } from '../../firebase-config'
import { buildTask } from '../../lib/robotCommands'
import { enqueueTask } from '../../lib/enqueueTask'
import { useAtom, useSetAtom } from 'jotai'
import { currentRobot, deliverItem, deliverTo, deliverFrom, escortFrom, escortName, escortTo, fetchFrom, fetchTo, fetchItem, isCheckinOpen,isCheckedinOpen, isComeHereOpen, isDisplayMessageOpen, isDeliverOpen, isEscortOpen, isFetchOpen, isGotoOpen, isPageChanged, isQrOpen, isShowAnnounce, locationArray, qrCodeTitle, robotNickname, savedAnnounced, savedMessage, savedSelectedLoc, selectedPage, webUrl } from '../store/DataStore'
import GotoPopup from '../popups/GotoPopup'
import useActionDefaultItems from '../useActionDefaultItems'
import MessagePopup from '../popups/MessagePopup'
import AnnouncePopup from '../popups/AnnouncePopup'
import DeliverPopup from '../popups/DeliverPopup'
import EscortPopup from '../popups/EscortPopup'
import FetchPopup from '../popups/FetchPopup'
import QRPopup from '../popups/QRPopup'
import ComeHerePopup from '../popups/ComeHerePopup'
import CheckinPopup from '../popups/CheckinPopup'
import CheckedinPopup from '../popups/CheckedinPopup'


const actionBtns = [
  { id: 1, image: locationIcon, text: 'Come Here' },
  // { id: 2, image: followMe, text: 'Follow Me' },
  { id: 2, image: targetIcon, text: 'Go To' },
  { id: 3, image: escortIcon, text: 'Escort' },
  { id: 4, image: fetchIcon, text: 'Fetch' },
  //{ id: 5, image: deliverIcon, text: 'Deliver' },
  { id: 6, image: speakerIcon, text: 'Announce' },
  // { id: 2, image: screenIcon, text: 'Clear Screen' },
  { id: 8, image: videosIcon, text: 'Play Video' },
  { id: 9, image: qrIcon, text: 'Show QR Code' },
  { id: 10, image: checkIcon, text: 'Check In Patient' },
  { id: 11, image: checkIcon, text: 'Checked In Patients' },
  { id: 7, image: messageIcon, text: 'Show Message' },
];

const deliverBtn = { id: 5, image: deliverIcon, text: 'Deliver' };
const locationRelevantTaskTypes = ['goto', 'come_here', 'escort', 'deliver', 'fetch'];

const ActionsFragment = ( {userName} ) => {
  const [gotoStatus, setGotoStatus] = useAtom(isGotoOpen);
  const [escortStatus, setEscortStatus] = useAtom(isEscortOpen);
  const [deliverStatus, setDeliverStatus] = useAtom(isDeliverOpen);
  const [fetchStatus, setFetchStatus] = useAtom(isFetchOpen);
  const [showMessageStatus, setShowMessageStatus] = useAtom(isDisplayMessageOpen);
  const [showAnnounce, setShowAnnounce] = useAtom(isShowAnnounce);
  const [showQRStatus, setShowQRStatus] = useAtom(isQrOpen);
  const [comeHereStatus, setComeHereStatus] = useAtom(isComeHereOpen);
  const [checkinStatus, setCheckinStatus] = useAtom(isCheckinOpen);
  const [checkedinStatus, setCheckedinStatus] = useAtom(isCheckedinOpen);
  const [savedRobot] = useAtom(currentRobot);
  const [savedNickname] = useAtom(robotNickname);
  const [selectedLocation, setSelectedLocation] = useAtom(savedSelectedLoc);
  const [displayedMessage] = useAtom(savedMessage);
  const [announcedMessage] = useAtom(savedAnnounced);
  const [deliverItemSaved] = useAtom(deliverItem);
  const [deliverToSaved] = useAtom(deliverTo);
  const [deliverFromSaved] = useAtom(deliverFrom);
  const [escortFromSaved] = useAtom(escortFrom);
  const [escortToSaved] = useAtom(escortTo);
  const [escortNameSaved] = useAtom(escortName);
  const [fetchItemSaved] = useAtom(fetchItem);
  const [fetchFromSaved] = useAtom(fetchFrom);
  const [fetchToSaved] = useAtom(fetchTo);
  const [qrTitleSaved] = useAtom(qrCodeTitle)
  const [qrUrlSaved] = useAtom(webUrl);

  const [actionButtons, setActionButtons] = useState(actionBtns);
  const [currNetworkStatus, setCurrNetworkStatus] = useState('');
  const [currBatteryAmount, setCurrBatteryAmount] = useState(0);
  const [currentTaskCard, setCurrentTaskCard] = useState(null);
  const [lastTaskCard, setLastTaskCard] = useState(null);
  const [locArray, setLocArray] = useAtom(locationArray);
  const [rawStatus, setRawStatus] = useState('');
  const intervalRef = useRef();
  const [currentLoc, setCurrentLoc] = useState('');
  const [kioskLoc, setKioskLoc] = useState('');
  const [taskListenerNetworkStatus, setTaskListenerNetworkStatus] = useState('');
  const { fetchItems: fetchDefaultItems, deliverItems: deliverDefaultItems } = useActionDefaultItems(savedRobot);

  const startTimer = () => {
    //TODO - CHANGE INTERVAL TO APPROXIMATE INTERVAL
    // if (!intervalRef.current) {
    //   intervalRef.current = setInterval(() => {
    //     setDuration(prevDuration => prevDuration + 1);
    //   }, 400);
    // }
  };
  const pauseTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  const resetTimer = () => {
    pauseTimer();
    // setDuration(0);
  };

  // const getPracticeId = async () => {
  //   const practiceIdPath = `Companies/Zeeno_Dev/Dolphin/${savedRobot}`;
  //   const practiceIdRef = doc(db, practiceIdPath);
  // try {
  //     const docSnap = await getDoc(practiceIdRef);
  //     if (docSnap.exists()) {
  //         const practiceId = docSnap.data().practiceid;
  //         console.log('Practice ID:', practiceId);
  //         return practiceId;
  //     } else {
  //         console.log('No such document!');
  //     }
  // } catch (error) {
  //     console.error('Error getting document:', error);
  // }
// };
// async function fetchPatientsFromDB(savedRobot){
//     const practiceId = await getPracticeId();
//     let data = JSON.stringify({
//         "practiceId": practiceId,
//         "robotSN": savedRobot
//         });

//         let config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: 'https://zeeno-api.azurewebsites.net/bot-appointments',
//         headers: { 
//             'Content-Type': 'application/json'
//         },
//         data : data
//         };

//         axios.request(config)
//         .then((response) => {
//         console.log(JSON.stringify(response.data));
//         })
//         .catch((error) => {
//         console.log(error);
//         });
// };  

  async function getCurrentLocation(db) {
    if (savedRobot !== '') {
      const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
      const docRef = doc(db, docPath);
      try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const currentLocation = docSnap.data().current_location;
          setCurrentLoc(currentLocation);
          return currentLocation;
        } else {
          console.log("No such document!");
          return [];
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
        return [];
      }
    } else {
      console.log("No robot saved");
      return [];
    }
  }

  async function getKioskLocation(db) {
    if (savedRobot !== '') {
      const settingsPath = `/Companies/Zeeno_Dev/Settings/${savedRobot}/Kiosk/kiosksetting`;
      const settingsDocRef = doc(db, settingsPath);
      try {
        const settingsDocSnap = await getDoc(settingsDocRef);
        if (settingsDocSnap.exists()) {
            const settingsData = settingsDocSnap.data();
            let areaSelected = settingsData.location || "unknown";
            if (locArray.indexOf(areaSelected) === -1 && locArray.length) {
              areaSelected = locArray[0];
            }
            console.log('Area selected:', areaSelected);
            setKioskLoc(areaSelected);
        } else {
            console.log("Settings document does not exist!");
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
        return [];
      }
    } else {
      console.log("No robot saved");
      return [];
    }
  }

  async function getLocationList(db) {
    if (savedRobot !== '') {
      const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Locations/backuplocations`;
      const docRef = doc(db, docPath);
      try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const locations = docSnap.data().locations;
          setLocArray(locations);
          console.log("getLocationList: ", locations);
          getKioskLocation(db);
          return locations;
        } else {
          console.log("No such document!");
          return [];
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
        return [];
      }
    } else {
      console.log("No robot saved");
      return [];
    }
  }

  const normalizeTask = (taskDoc) => ({
    id: taskDoc.id,
    ...taskDoc.data()
  });

  const getTimestampMillis = (task) => {
    if (task?.timestamp?.toMillis) {
      return task.timestamp.toMillis();
    }
    if (task?.timestamp?.seconds) {
      return task.timestamp.seconds * 1000;
    }
    return 0;
  };

  const getHistoryTimestampMillis = (task) => {
    if (task?._deletedAt?.toMillis) {
      return task._deletedAt.toMillis();
    }
    if (task?._deletedAt?.seconds) {
      return task._deletedAt.seconds * 1000;
    }
    if (task?._lastSyncedAt?.toMillis) {
      return task._lastSyncedAt.toMillis();
    }
    if (task?._lastSyncedAt?.seconds) {
      return task._lastSyncedAt.seconds * 1000;
    }
    return getTimestampMillis(task);
  };

  const sortTasksByTimestamp = (tasks) => (
    [...tasks].sort((a, b) => getTimestampMillis(b) - getTimestampMillis(a))
  );

  const sortHistoryTasksByTimestamp = (tasks) => (
    [...tasks].sort((a, b) => getHistoryTimestampMillis(b) - getHistoryTimestampMillis(a))
  );

  const isCurrentTask = (task) => task.status === "active" || task.status === "paused";
  const isLocationRelevantTask = (task) => locationRelevantTaskTypes.includes(task?.content?.[0]);
  const isLastTaskCandidate = (task) => {
    if (task?._deleted) {
      return task?.status !== 'upcoming';
    }
    return !['upcoming', 'active', 'paused'].includes(task?.status);
  };

  const getTaskType = (taskContent = []) => {
    switch (taskContent[0]) {
      case 'goto':
        return { type: 'Go To', content: [taskContent[1]] };
      case 'come_here':
        return { type: 'Come Here', content: [taskContent[1]] };
      case 'escort':
        return { type: 'Escort', content: [taskContent[1], '->', taskContent[3]].join(' ') };
      case 'deliver':
        return { type: 'Deliver', content: [taskContent[1], 'from', taskContent[2], '->', taskContent[3]].join(' ') };
      case 'fetch':
        return { type: 'Fetch', content: [taskContent[1], '->', taskContent[3]].join(' ') };
      case 'video':
        return { type: 'Video', content: [taskContent[2]] };
      default:
        return { type: taskContent[0] || '', content: taskContent[0] || '' };
    }
  };

  const formatTaskForCard = (taskData) => {
    const taskInfo = getTaskType(taskData.content);
    const isArchivedTask = !!taskData._deleted;
    const formattedStatus = isArchivedTask
      ? (taskData.status === 'active' ? 'Completed' :
        (taskData.status === 'paused' ? 'Paused' :
        (taskData.status ? taskData.status.charAt(0).toUpperCase() + taskData.status.slice(1) : 'Completed')))
      : (taskData.status === 'active' ? 'In Progress' :
        (taskData.status === 'paused' ? 'At Hold' :
        (taskData.status ? taskData.status.charAt(0).toUpperCase() + taskData.status.slice(1) : '')));

    return {
      taskId: taskData.id,
      batteryAmount: taskData.battery_amount ? taskData.battery_amount : 0,
      wifiStatus: taskData.wifi_status || '',
      nextTasks: taskData.next_tasks ? taskData.next_tasks : 0,
      task: taskInfo.type,
      taskContent: taskInfo.content,
      status: formattedStatus
    };
  };

  function getCurrentTask(db) {
    if (!savedRobot) {
      setCurrentTaskCard(null);
      setRawStatus('');
      return () => {};
    }

    const collectionPath = `Companies/Zeeno_Dev/Actions/${savedRobot}/Logs`;
    const collectionRef = collection(db, collectionPath);

    const onTaskUpdate = (querySnapshot) => {
      const sortedTasks = sortTasksByTimestamp(querySnapshot.docs.map(normalizeTask));
      const currentTask = sortedTasks.find(isCurrentTask) || null;

      if (currentTask) {
        setRawStatus(currentTask.status);
        setCurrBatteryAmount(currentTask.battery_amount ? currentTask.battery_amount : 0);
        setCurrentTaskCard(formatTaskForCard(currentTask));
      } else {
        setRawStatus('');
        setCurrBatteryAmount(0);
        setCurrentTaskCard(null);
        console.log("No active or paused tasks found");
      }
    };

    try {
      return onSnapshot(collectionRef, onTaskUpdate);
    } catch (error) {
      setCurrentTaskCard(null);
      console.error("Error listening to current task documents: ", error);
      return () => {};
    }
  }

  function getLastTask(db) {
    if (!savedRobot) {
      setLastTaskCard(null);
      return () => {};
    }

    const collectionPath = `Companies/Zeeno_Dev/ActionsHistory/${savedRobot}/Logs`;
    const collectionRef = collection(db, collectionPath);

    const onTaskUpdate = (querySnapshot) => {
      const sortedTasks = sortHistoryTasksByTimestamp(querySnapshot.docs.map(normalizeTask));
      const lastTask = sortedTasks.find(task => isLocationRelevantTask(task) && isLastTaskCandidate(task)) || null;
      setLastTaskCard(lastTask ? formatTaskForCard(lastTask) : null);
    };

    try {
      return onSnapshot(collectionRef, onTaskUpdate);
    } catch (error) {
      setLastTaskCard(null);
      console.error("Error listening to last task history documents: ", error);
      return () => {};
    }
  }

  async function getCurrentPing(db) {
    if (!savedRobot || savedRobot.trim() === '') {
      console.log("No robot saved");
      return;
    }

    const docPath = `Companies/Zeeno_Dev/Actions/${savedRobot}/Ping/pingsetting`;
    const docRef = doc(db, docPath);

    onSnapshot(docRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        const isOnline = data.is_online;
        console.log("Current online status: ", isOnline);
        if (isOnline) {
          setCurrNetworkStatus('Online');
          setTaskListenerNetworkStatus('Online');
        } else {
          setCurrNetworkStatus('Offline');
          setTaskListenerNetworkStatus('Offline');
        }
      } else {
        console.log("Document does not exist!");
      }
    }, (error) => {
      console.error("Error listening to document: ", error);
    });
  }


  function parseVersion(versionStr) {
    const match = versionStr.match(/^(\d+)\.(\d+)\.(\d+)$/);
    if (!match) {
      throw new Error(`Invalid version string: "${versionStr}"`);
    }

    const [, major, minor, patch] = match;
    return {
      major: parseInt(major, 10),
      minor: parseInt(minor, 10),
      patch: parseInt(patch, 10)
    };
  }

  async function getAppVersionString(db){
    if (savedRobot !== '') {
      const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/settings`;
      const docRef = doc(db, docPath);
      try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const settings = docSnap.data();
          return settings.app_version;
        }
        return {};
      } catch (error) {
        console.error("Error fetching app version: ", error);
        return {};
      }
    }
    console.log("No robot saved");
    return {};
  }

  async function doesAppVersionSupportDeliver(db){
    try {
      //returns true if app version is >= 1.0.109
      const appVersionString = await getAppVersionString(db);
      const appVersion = parseVersion(appVersionString);
      
      return ((appVersion.major>1)||(
            (appVersion.major===1)&&(
              ((appVersion.minor>0))||
              ((appVersion.minor===0)&&(appVersion.patch>=109))
            )
          )
        );
    } catch (error) {
      console.error("Error in doesAppVersionSupportDeliver: ", error);
      return false;
    }
    
  }

  function insertButton(buttons, btnToInsert, afterId) {
    const index = buttons.findIndex(b => b.id === afterId);
    if (index === -1) return [...buttons, btnToInsert]; // fallback to append
    const result = [...buttons];
    result.splice(index + 1, 0, btnToInsert);
    return result;
  }

  const setActionButtonsForLabMode = (isDeliverSupported) => {
    const allowedIds = [1, 2, 4, 6, 7, 8, 9]; // Exclude Deliver (5)
    let buttons = actionBtns.filter(btn => allowedIds.includes(btn.id));
    if (isDeliverSupported) {
      buttons = insertButton(buttons, deliverBtn, 4); // Insert after Fetch
    }
    setActionButtons(buttons);
  };

  const setActionButtonsForPracticeMode = (isDeliverSupported) => {
    const allowedIds = [1, 2, 3, 4, 6, 7, 8, 9, 10, 11]; // Exclude Deliver (5)
    let buttons = actionBtns.filter(btn => allowedIds.includes(btn.id));
    if (isDeliverSupported) {
      buttons = insertButton(buttons, deliverBtn, 4); // Insert after Fetch
    }
    setActionButtons(buttons);
  };

  async function getLabSettings(db) {
    if (savedRobot !== '') {
      const isDeliverSupported = await doesAppVersionSupportDeliver(db); // add check that app version >= 1.0.109
      console.log(`Does app version support deliver: ${isDeliverSupported}`);
      const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Lab/labsetting`;
      const docRef = doc(db, docPath);
      
      try {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const settings = docSnap.data();

          if(settings.is_labmode){
            setActionButtonsForLabMode(isDeliverSupported);
          }
          else{
            setActionButtonsForPracticeMode(isDeliverSupported);
          }

          return settings;
        }
        
        setActionButtonsForPracticeMode(isDeliverSupported);
        return {};
      } catch (error) {
        setActionButtons(actionBtns);
        console.error("Error fetching settings: ", error);
        return {};
      }
    }
    console.log("No robot saved");
    return {};
  }

  useEffect(() => {
    const unsubscribeCurrentTask = getCurrentTask(db);
    const unsubscribeLastTask = getLastTask(db);
    getLocationList(db);
    if (savedRobot) {
      getCurrentPing(db);
      getLabSettings(db);
      //fetchPatientsFromDB(savedRobot)
    }
    return () => {
      if (unsubscribeCurrentTask) {
        unsubscribeCurrentTask();
      }
      if (unsubscribeLastTask) {
        unsubscribeLastTask();
      }
    };
  }, [db, savedRobot]);

  useEffect(() => {
    getLocationList(db);
    getCurrentLocation(db);
    getKioskLocation(db);
  }, [gotoStatus, deliverStatus, escortStatus, fetchStatus, showQRStatus, comeHereStatus])

  useEffect(() => {
    if (rawStatus === 'active') {
      startTimer();
    } else if (rawStatus === 'paused' || currNetworkStatus === 'Offline') {
      pauseTimer();
    } else if (rawStatus === 'done') {
      resetTimer();
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [rawStatus, db]);


  // Builds a task with the user and robot names and adds it to the queue.
  const sendTask = (command, args) => enqueueTask(
    db, savedRobot, buildTask(command, args, { userName, robotName: savedNickname }));

  const sendToLocation = async () => {
    await sendTask('goto', { location: selectedLocation || 'home base' });
    setSelectedLocation('');
  }

  const sendComeHereToLocation = async () => {
    await sendTask('come_here', { location: selectedLocation || 'home base' });
    setSelectedLocation('');
  }

  const escortUser = async () => {
        const newDocRef = await sendTask('escort', {
          name: escortNameSaved,
          from: escortFromSaved,
          to: escortToSaved,
        });
        console.log('Document successfully updated with ID: ', newDocRef.id);
  }

  const deliver = async () => {

    try {
       // fallbacks just in case
       const item = (deliverItemSaved || '').trim();
       const from = (deliverFromSaved || 'unknown').trim();
       const to   = (deliverToSaved   || 'unknown').trim();
       if (!item || !from || !to) {
         console.warn('Missing deliver fields', { item, from, to });
         return;
       }

        const newDocRef = await sendTask('deliver', { item, from, to });
        console.log('Document successfully updated with ID: ', newDocRef.id);
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  }

  const fetchUser = async () => {
    
    try {
        console.log("***Temi:fetchUser values", {
          savedRobot,
          kioskLoc,
          currentLoc,
          fetchItemSaved,
          fetchFromSaved,  
          fetchToSaved,
        });
        
        // fallbacks just in case
       const item = (fetchItemSaved || '').trim();
       const from = (fetchFromSaved || 'unknown').trim();
       const to   = (fetchToSaved   || 'unknown').trim();
       if (!item || !from || !to) {
         console.warn('Missing fetch fields', { item, from, to });
         return;
       }

        const newDocRef = await sendTask('fetch', { item, from, to });
        console.log('Document successfully updated with ID: ', newDocRef.id);
        
    } catch (error) {
        console.error('Error updating document: ', error);
    }
}


  // const displayMessage = async (type) => {
  //   const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
  //   const docRef = doc(db, docPath);
  //   if (type === 'display') {
  //     try {
  //       await updateDoc(docRef, {
  //         display_message: displayedMessage,
  //         toggle_message: true
  //       });
  //     } catch (error) {
  //       console.error('error updated location: ', error);
  //     }
  //   } else if (type === 'announce') {
  //     try {
  //       await updateDoc(docRef, {
  //         announce_message: announcedMessage,
  //         toggle_announce: true
  //       });
  //     } catch (error) {
  //       console.error('error updated location: ', error);
  //     }
  //   }
  // }
  const displayMessage = async (type) => {
    const newDocRef = type === 'message'
      ? await sendTask('message', { text: displayedMessage })
      : await sendTask('announcement', { text: announcedMessage });
    console.log('Document successfully updated with ID: ', newDocRef.id);
}

  const sendQR = async () => {
    const newDocRef = await sendTask('qr', { url: qrUrlSaved, title: qrTitleSaved });
    console.log('Document successfully updated with ID: ', newDocRef.id);



    // const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
    // const docRef = doc(db, docPath);
    // console.log(qrUrlSaved);
    // try {
    //   await updateDoc(docRef, {
    //     qrcode_title: qrTitleSaved,
    //     qrcode_url: qrUrlSaved,
    //     is_qrshow: true
    //   });
    // } catch (error) {
    //   console.error('error updated location: ', error);
    // }
  }

  const sendCheckedinPatients = async () => {
    //confirmAppointmentGPS(savedPatientList[0].Id)
    // console.log("Your checked ids are: " + checkedIds );
  }

  return (
    <div className='h-full overflow-auto bg-[#F0F2FF] px-4 py-4 sm:px-6 lg:min-h-screen lg:px-8 lg:py-6 xl:px-10'>
      <GotoPopup isOpen={gotoStatus} onClose={() => setGotoStatus(false)} onSend={() => sendToLocation()} locations={locArray}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Go To</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please choose ${savedNickname} destination`}</p>
      </GotoPopup>
      <EscortPopup currentLocation={currentLoc} kioskLocation={kioskLoc} isOpen={escortStatus} onClose={() => setEscortStatus(false)} onSend={() => escortUser()} locations={locArray}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Escort</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} escort locations:`}</p>
      </EscortPopup>
      <FetchPopup currentLocation={currentLoc} areaSelected={kioskLoc} isOpen={fetchStatus} onClose={() => setFetchStatus(false)} onSend={() => fetchUser()} locations={locArray} defaultItems={fetchDefaultItems}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Fetch</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} fetch locations:`}</p>
      </FetchPopup>
      <DeliverPopup currentLocation={kioskLoc} isOpen={deliverStatus} onClose={() => setDeliverStatus(false)} onSend={() => deliver()} locations={locArray} defaultItems={deliverDefaultItems}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Deliver</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} deliver locations:`}</p>
      </DeliverPopup>
      <AnnouncePopup isOpen={showAnnounce} onClose={() => setShowAnnounce(false)} onSend={() => displayMessage('announce')}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Announce Message</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Enter message to announce on ${savedNickname}`}</p>
      </AnnouncePopup>
      <MessagePopup isOpen={showMessageStatus} onClose={() => setShowMessageStatus(false)} onSend={() => displayMessage('message')}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Display Message</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Enter message to display on ${savedNickname}`}</p>
      </MessagePopup>
      <QRPopup isOpen={showQRStatus} onClose={() => setShowQRStatus(false)} onSend={() => sendQR()}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Add QR Code</h2>
      </QRPopup>
      <ComeHerePopup isOpen={comeHereStatus} onClose={() => setComeHereStatus(false)} onSend={() => sendComeHereToLocation()} locations={locArray} currentLocation={currentLoc}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Come Here</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} destination location:`}</p>
      </ComeHerePopup>
      <CheckinPopup isOpen={checkinStatus} onClose={() => setCheckinStatus(false)} >
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Check In Patient</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} to check in patient`}</p>
      </CheckinPopup>
      <CheckedinPopup isOpen={checkedinStatus} onClose={() => setCheckedinStatus(false)} onSend={() => sendCheckedinPatients()} userName={userName} savedNickname={savedNickname} batteryAmount={currBatteryAmount} locations={locArray} areaSelected={kioskLoc}>
        <h2 className="text-lg font-medium leading-6 text-[#3C5BD2] font-heebo">Checked In Patients</h2>
        <p className="text-md text-gray-800 font-heebo font-light mt-1">{`Please set ${savedNickname} to escort patient`}</p>
      </CheckedinPopup>
      <Header />
      {currentTaskCard && (
        <CurrentTaskSummary
          task={currentTaskCard.task}
          taskContent={currentTaskCard.taskContent}
          status={currentTaskCard.status}
        />
      )}
      <div className='mt-6 flex items-end justify-between gap-3 lg:mt-8 2xl:mt-14'>
        <h1 className='font-heebo text-xl text-[#273a84]'>Actions</h1>
      </div>
      <ActionList buttons={actionButtons} />
      {currentTaskCard && <div id="current-task-card">
        <h1 className='mt-10 font-heebo text-xl text-[#273a84] lg:mt-12 2xl:mt-20'>Current Task</h1>
        <Footer
          taskId={currentTaskCard.taskId}
          robotName={savedNickname}
          networkStatus={currNetworkStatus}
          batteryAmount={currentTaskCard.batteryAmount}
          wifiStatus={currentTaskCard.wifiStatus}
          nextTasks={currentTaskCard.nextTasks}
          task={currentTaskCard.task}
          taskContent={currentTaskCard.taskContent}
          status={currentTaskCard.status}
          taskLabel="Current Task"
        />
      </div>}
      {lastTaskCard && <div>
        <h1 className='mt-8 font-heebo text-xl text-[#273a84] lg:mt-10'>Last Task</h1>
        <Footer
          taskId={lastTaskCard.taskId}
          robotName={savedNickname}
          networkStatus={taskListenerNetworkStatus || currNetworkStatus}
          batteryAmount={lastTaskCard.batteryAmount}
          wifiStatus={lastTaskCard.wifiStatus}
          nextTasks={lastTaskCard.nextTasks}
          task={lastTaskCard.task}
          taskContent={lastTaskCard.taskContent}
          status={lastTaskCard.status}
          taskLabel="Last Task"
          isReadOnly={true}
        />
      </div>}
    </div>
  )
}

const CurrentTaskSummary = ({ task, taskContent, status }) => {
  const onJumpToCurrentTask = () => {
    document.getElementById('current-task-card')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };

  return (
    <button
      type="button"
      className="mt-6 flex w-full min-w-0 items-center justify-between gap-3 rounded-2xl border border-[#8290F8] bg-white px-4 py-3 text-left shadow-sm lg:hidden"
      onClick={onJumpToCurrentTask}
      aria-label="Jump to current task details"
    >
      <div className="min-w-0">
        <div className="font-heebo text-xs font-medium uppercase leading-4 text-[#3C5BD2]">
          Current Task
        </div>
        <div className="mt-1 truncate font-heebo text-base font-medium leading-5 text-[#273a84]">
          {task || 'Current Task'}
        </div>
        <div className="mt-1 truncate font-heebo text-sm leading-4 text-gray-500">
          {taskContent || status}
        </div>
      </div>
      <span className="flex-shrink-0 font-heebo text-base font-medium text-[#3C5BD2]">
        View
      </span>
    </button>
  );
};

const ActionList = ({buttons}) => {
  const [pressedItemId, setPressedItemId] = useState(null);
  const [savedRobot] = useAtom(currentRobot);
  const setIsGotoOpen = useSetAtom(isGotoOpen);
  const setIsDeliverOpen = useSetAtom(isDeliverOpen);
  const setIsEscortOpen = useSetAtom(isEscortOpen);
  const setIsFetchOpen = useSetAtom(isFetchOpen);
  const setIsShowMsgOpen = useSetAtom(isDisplayMessageOpen);
  const setIsShowAnnounce = useSetAtom(isShowAnnounce);
  const setIsShowQRCode = useSetAtom(isQrOpen);
  const setIsShowComeHere = useSetAtom(isComeHereOpen);
  const setIsShowCheckin = useSetAtom(isCheckinOpen);
  const setIsShowCheckedin = useSetAtom(isCheckedinOpen);
  const setSelectedPage = useSetAtom(selectedPage);
  const setIsPageChanged = useSetAtom(isPageChanged);


  function setupFollowMeListener(savedRobot, db) {
    if (savedRobot !== '') {
      const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
      const docRef = doc(db, docPath);

      const unsubscribe = onSnapshot(docRef, (docSnap) => {
        if (docSnap.exists()) {
          const followMe = docSnap.data().follow_me;
          if (followMe === false) {
            console.log("value was reset to false");
          }
        } else {
          console.log("No such document!");
        }
      }, (error) => {
        console.error("Error listening to document: ", error);
      });

      return unsubscribe; // This function can be called to stop listening to changes
    } else {
      return null;
    }
  }

  useEffect(() => {
    const unsubscribe = setupFollowMeListener(savedRobot, db);
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedRobot, db]); // Dependencies array

  const onActionClicked = async (index, name) => {
    if (savedRobot !== '') {
      //const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
      //const docRef = doc(db, docPath);
      switch (name) {
        // case "Follow Me":
        //   try {
        //     await updateDoc(docRef, {
        //       follow_me: true
        //     });
        //   } catch (error) {
        //     console.error('Error updating document: ', error);
        //   }
        //   break;
        case "Go To":
          setIsGotoOpen(true);
          break;
        case "Deliver":
          setIsDeliverOpen(true);
          break;
        case "Escort":
          setIsEscortOpen(true);
          break;
        case "Fetch":
          setIsFetchOpen(true);
          break;
        case "Announce":
          setIsShowAnnounce(true);
          break;
        case "Show Message":
          setIsShowMsgOpen(true);
          break;
        // case "Clear Screen":
        //   try {
        //     await updateDoc(docRef, {
        //       toggle_clear: true
        //     });
        //   } catch (error) {
        //     console.error('Error updating document: ', error);
        //   }
        //   break;
        case "Play Video":
          setIsPageChanged(true);
          setSelectedPage(3);
          break;
        case "Show QR Code":
          setIsShowQRCode(true);
          break;
        case "Come Here":
          setIsShowComeHere(true);
          break;
        case "Check In Patient":
          setIsShowCheckin(true);
          break;
          case "Checked In Patients":
            setIsShowCheckedin(true);
            break;
        default:
          break;
      }
    }
  }

  return (
    <div className="mt-6 grid w-full grid-cols-1 gap-4 select-none sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5">
      {buttons.map((item, index) => (
        <div
          key={item.id}
          className="flex min-h-[148px] flex-col items-center justify-center rounded-2xl bg-[#3C5BD2] bg-opacity-10 px-5 py-6 text-center hover:bg-opacity-5 cursor-pointer active:bg-opacity-100 sm:min-h-[172px] lg:px-6"
          onClick={() => onActionClicked(index, item.text)}
          onMouseDown={() => setPressedItemId(index)}
          onMouseUp={() => setPressedItemId(null)}
        >
          <IconTint src={item.image} alt="" color={pressedItemId === index ? '#FFFFFF' : '#3C5BD2'} className="h-12 w-12 object-contain sm:h-16 sm:w-16 lg:h-14 lg:w-14" />
          <p className={`mt-4 font-heebo text-lg leading-tight sm:text-xl ${pressedItemId === index ? 'text-white' : 'text-[#273a84]'}`}>{item.text}</p>
        </div>
      ))}
    </div>
  )
}

export default ActionsFragment
